import React from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from '../../../context/ThemeProvider';
import useLanguage from '../../../hooks/useLanguage';
import PackagesModalHeader from './PackagesModalHeader/PackagesModalHeader';
import PackagesModalFooter from './PackagesModalFooter/PackagesModalFooter';
import PackagesModalContent from './PackagesModalContent/PackagesModalContent';
import CloseIcon from '../../../svg/close.svg';

const PackagesModal = ({
  packagesData,
  promoCode,
  selected,
  closeModalHandler,
  open,
}) => {
  
  const langToggle = useLanguage;

  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [mail, setMail] = React.useState('');
  const [price, setPrice] = React.useState(false);
  
  const [dat, setDat] = React.useState('');
  const [signature, setSignature] = React.useState('');

  const { themeMode } = React.useContext(ThemeContext);

  const newPromoCode = promoCode.map((it) => it.promocode)

  const promoHandler = (e) => {
    if (newPromoCode.includes(e.target.value)) {
      setPrice(true);
    } else {
      setPrice(false);
    }
  };

  const currency =
    themeMode === 'Грн'
      ? 'UAH'
      : themeMode === 'Руб'
      ? 'RUB'
      : themeMode === 'Usd'
      ? 'USD'
      : 'EUR';

  const defaultPrice =
    themeMode === 'Грн'
      ? selected.price_uah
      : themeMode === 'Руб'
      ? selected.price_rub
      : themeMode === 'Usd'
      ? selected.price_usd
      : selected.price_eur;

  const salePrice =
    themeMode === 'Грн'
      ? selected.sale_uah
      : themeMode === 'Руб'
      ? selected.sale_rub
      : themeMode === 'Usd'
      ? selected.sale_usd
      : selected.sale_eur;

  const paymantPrice = price === true ? salePrice : defaultPrice;
  const serviceName =
    langToggle(packagesData.Titles.title_ua, packagesData.Titles.title_ru) +
    ' ' +
    langToggle(
      packagesData.Titles.sub_title_ua,
      packagesData.Titles.sub_title_ru
    ) +
    ' / ' +
    langToggle(selected.rate_ua, selected.rate_ru);

  const orderId = Math.floor(1 + Math.random() * 900000000);
  const language = langToggle('uk', 'ru');


  function debounce(func, wait, immediate) {
    var timeout;
  
    return function executedFunction() {
      var context = this;
      var args = arguments;
        
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
  
      var callNow = immediate && !timeout;
    
      clearTimeout(timeout);
  
      timeout = setTimeout(later, wait);
    
      if (callNow) func.apply(context, args);
    };
  }
  
  const payHandler = debounce(function() {
    let xhr = new XMLHttpRequest();
                xhr.open("POST","https://payment.shoschool.com/pay" ); 
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.send(JSON.stringify(
                 { 
                  orderId: orderId,
                  description: serviceName,
                  sender_first_name: firstName,
                  sender_last_name: lastName,
                  phone: phone,
                  mail: mail,
                  amount: paymantPrice,
                  currency: currency,
                  language: language,
                  })); 
                xhr.onreadystatechange = function () {
                    if (this.readyState === 4 && this.status === 200) {
                        const data = JSON.parse(this.responseText);
                        setDat(data.data)
                        setSignature(data.signature)

                    }
                }
  }, 250);

  return (

    <div className={open ? 'packages-modal is-open' : 'packages-modal'}>
      <div
        className={
          open ? 'packages-modal__overlay is-open' : 'packages-modal__overlay'
        }
        onClick={closeModalHandler}
        role="presentation"
      ></div>
      <div className="packages-modal__wrapper">
        <div
          className={
            open
              ? 'packages-modal__form-wrapper is-open'
              : 'packages-modal__form-wrapper'
          }
        >
          <button className="packages-modal__close" onClick={closeModalHandler}>
            close
            <CloseIcon className="packages-modal__close-icon" />
          </button>
          <form
            className="packages-modal__form"
            action="https://www.liqpay.ua/api/3/checkout"
          >
            <input type="hidden" name="amount" value={paymantPrice} />
            <input type="hidden" name="currency" value={currency} />
            <input type="hidden" name="language" value="language" />
            <input type="hidden" name="description" value={serviceName} />
            <input type="hidden" name="orderId" value={orderId} />

            <input type="hidden" name="data" value={dat} />
            <input type="hidden" name="signature" value={signature} />

            <PackagesModalHeader
              packagesData={packagesData}
              selected={selected}
            />
            <PackagesModalContent
              open={open}
              firstName={firstName}
              setFirstName={setFirstName}
              lastName={lastName}
              setLastName={setLastName}
              phone={phone}
              setPhone={setPhone}
              mail={mail}
              setMail={setMail}
              promoHandler={promoHandler}
              price={price}
              salePrice={salePrice}
              defaultPrice={defaultPrice}
              payHandler={payHandler}
              debounce={debounce}
            />
         
            <PackagesModalFooter open={open} payHandler={payHandler} />
          </form>
        </div>
      </div>
    </div>
  );
};

PackagesModal.propTypes = {
  packagesData: PropTypes.object,
  promoCode: PropTypes.array,
  selected: PropTypes.object,
  openModalHandler: PropTypes.func,
  open: PropTypes.bool,
};

export default PackagesModal;
